import React, {Component} from 'react'

import Media from '../Media'
import Content from '../Content'

import Asset from '../../models/Asset'
import Entry from '../../models/Entry'

import {
  NavLink,
  withRouter
} from 'react-router-dom';

class Button extends Component {

  uri;
  timeDown;

  constructor(props) {
    super(props);
    this.state = {active:0};
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  mouseDown = (ev) => {
      this.timeDown = new Date().getTime();
      this.setState({active:1});

  }

  mouseUp = (ev) => {

      const _this = this;
      let elapsed = new Date().getTime() - this.timeDown;

      let timer = (elapsed < 300) ? (300 - elapsed) : 0;

      setTimeout(function(){

          _this.setState({active:0});

          setTimeout(function(){

              _this.props.history.push(_this.uri);

          },400);

      },timer)



  }

  render () {

    const {entry, format} = this.props;

    let active = (this.state.active) ? 'is-active' : '';

    if(format == 'vertical') {
    return (

          <Entry id={entry.internalLink} render={

          (link) => {

              this.uri = link.uri;

            return (
              <div className={"Item Item--vertical Item--bigButton "+active}  >
              <div className="Item-head">
                  <Content html={'<h1>'+entry.title+'</h1><h4>Press the big button&trade;</h4>'}/>
                </div>
              <div class="Item-pos">
              <div className="Item-media" onMouseDown={this.mouseDown} onMouseUp={this.mouseUp}>
                  <Media original={true} id={entry.image[0]} />
                </div>
              </div>
                

              </div>
            )

           }}/>

    )} else {
      return (

          <Entry id={entry.internalLink} render={

          (link) => {

              this.uri = link.uri;

            return (
              <div className={"Item Item--horizontal Item--bigButton "+active}  >
              <div className="Item-head">
                  <Content>
                    <h1>{entry.title}</h1>
                    <h4>Press the big button&trade;</h4>
                  </Content>
                </div>
              <div class="Item-pos">
              <div className="Item-media" onMouseDown={this.mouseDown} onMouseUp={this.mouseUp}>
                  <Media original={true} id={entry.image[0]} />
                </div>
              </div>
                

              </div>
            )

           }}/>

    )
    }
  }
}

export default withRouter(Button);



// WEBPACK FOOTER //
// ./src/js/components/Button/Button.jsx